import { reqNewsList, reqNewsenList } from '@/api'

const state = {
  newsList: [],
  newsenList: [],
}
const mutations = {
  forNewsList(state, newsList) {
    state.newsList = newsList
  },
  forNewsenList(state, newsenList) {
    state.newsenList = newsenList
  },
}
const actions = {
  async newsList({ commit }) {
    const result = await reqNewsList()
    if (result.code === 200) {
      console.log(result);
      
      commit('forNewsList', result.data)
    }
  },
  async newsenList({ commit }) {
    const result = await reqNewsenList()
    if (result.code === 200) {
      commit('forNewsenList', result.data)
    }
  },
}
const getters = {}
export default {
  state,
  mutations,
  actions,
  getters,
}
